import { Routes } from '@angular/router';
import { CommunitiesRecipesSearchComponent } from './communities-recipes-search/communities-recipes-search.component';
import { CommunitiesRecipesPreviewComponent } from './communities-recipes-preview/communities-recipes-preview.component';

export const communitiesRecipesRoutes: Routes = [
  {
    path: 'search',
    component: CommunitiesRecipesSearchComponent,
  },
  {
    path: 'moderation/:sourceSystem/:fid',
    component: CommunitiesRecipesPreviewComponent,
  },
];
